<template>
    <div   class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="card">
              <button type="reset" @click="printReceipt" class="btn b-light btn-danger-light btn-sm">Print Receipt</button>
        </div>
        <div class="grid grid-cols-12">
  <div id="receipt">
    <div class="receipt-container pt-5">
      
      <table class="table">
          <tbody>
          <tr> 
              <td  style="width:70%">
                  <strong>&nbsp;नाव </strong> : {{customer.name}}<br>
                  
              </td>
              <td >
                   <strong>&nbsp;पावती क्र . #</strong> : {{invDetails.id}}
                  
              </td>
            </tr> <tr>  
                    <td  ><strong>&nbsp;संपर्क</strong> : {{customer.cell}}</td>
                    <td><strong>&nbsp;दिनांक</strong> : {{invDetails.entry_date}}<br></td>
          </tr>
          </tbody>
      </table>    

      <table class="receipt-table">
        <thead>
          <tr>
            <th style="width:10%;text-align:center">नं .</th>
            <th style="width:40%">तपशील </th>
            <th style="width:10%;text-align:center">नग </th>
            <th style="width:10%;text-align:center">रुपये</th>
            <th style="width:10%;text-align:center">एकूण  </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item ,index) in order_items" :key="item.id">
            <td style="text-align:center">{{ index+1 }}</td>
            <td>{{ (item.stich_name)?item.stich_name:item.prd_name }}</td>
            <td style="text-align:center" >{{ item.qty*(-1) }}</td>
            <td style="text-align:right">{{ formatCurrency(item.rate) }}</td>
            <td style="text-align:right">{{ formatCurrency(item.rate * (item.qty * (-1) )) }}</td>
          </tr>
           <tr v-for="n in (10-order_items.length)" :key="n">
            <td>&nbsp;</td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
          
          
        </tbody>
        <tfoot>
          <tr>
            <td colspan="5"><strong>Delivery Date : {{ invDetails.delivery }}</strong></td>
          </tr>
          <tr>
            <td colspan="4"><strong>एकूण रु</strong></td>
            <td>{{ formatCurrency(invDetails.total) }}</td>
          </tr>
          <tr>
            <td colspan="4"><strong>ऍडव्हांस</strong></td>
            <td>{{ formatCurrency(invDetails.paid) }}</td>
          </tr>
          <tr>
            <td colspan="4"><strong>येणे बाकी</strong></td>
            <td>{{ formatCurrency(invDetails.total-invDetails.paid) }}</td>
          </tr>
        </tfoot>
      </table> 
    </div>
  </div>
        </div>
        </div>
</template>

<script>
import axios from 'axios';
export default {
  data() {
    return {
      currentDate: new Date().toLocaleDateString(),
      receiptNumber: '12345',
      customer:[],
      invDetails:[],
      order_items:[], 
       
    };
  },
  computed: {
    totalAmount() {
      return this.items.reduce((total, item) => total + item.quantity * item.unitPrice, 0);
    },
  },
  mounted() {
      if(this.$route.query.q)
            this.getBasics(this.$route.query.q); 
  },
  methods: {
     async getBasics(invoiceid) {
           var self=this;
             axios.post('getInvoice',{invoiceid:invoiceid}).then(function (response) {
                         self.order_items=response.data.order_items;
                         self.employees=response.data.userDetails;
                         self.invDetails=response.data.invDetails;
                         self.customer=response.data.customer;
                        try {
                            document.getElementById("loader").remove();  
                            sel.printReceipt();
                        } catch (e) {}
                    }).then(()=>{ 
                        
                        
                        
                       //  self.printReceipt();
                  
                        });;
      },
    formatCurrency(value) {
      return value;//`$${value.toFixed(2)}`;
    },
    printReceipt() {
      window.print();
    },
  },
};
</script>

<style scoped>
@import url('https://fonts.googleapis.com/css2?family=Noto+Sans+Devanagari:wght@400;700&display=swap');
 
.receipt-container {
  width: 148mm;
  padding: 10mm;
  border: 1px solid #000;
  font-family: 'Noto Sans Devanagari', sans-serif;
}
.table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}
.table th, .table  td {
        line-height: 20px;
  border: 1px solid #000;
}
.receipt-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 20px;
}

.receipt-table th, .receipt-table td {
  border: 1px solid #000;
  padding: 5px;
  text-align: left;
}

@media print {
  button {
    display: none;
  }
#receipt{
    margin-top: 100px;
}
  .receipt-container {
    width: 148mm; 
    padding: 10mm;
    margin: 0;
    border: none;
  }
}
</style>
